<template>
  <div id="yrOneJssBar">
    <BarChart :chartData="chartData" :title="'Year One Juice Soluble Solids'" :yAxesLabel="'Brix'" :yAxesMin="12" :yAxesMax="20"/>
  </div>
</template>
<script>
import BarChart from '../charts/BarChart'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      chartData: []
    }
  },
  computed: {
    ...mapState(['mzs']),
    ...mapGetters(['calcYrOneJss', 'calcYrOneJssVrm'])
  },
  components: { BarChart },
  mounted() {
    this.chartDataCalc()
  },
  watch: {
    mzs: {
      handler(val) {
        this.chartDataCalc()
      },
      deep: true
    }
  },
  methods: {
    chartDataCalc() {
      let newLabels = []
      let newData = []
      let newDataVRM = []
      for(let i = 0; i < this.mzs.length; i++) {
        newLabels.push('Zone ' + (i + 1))
        // newData.push(this.mzs[i].yrOneJss.toFixed(2))
        newData.push(this.calcYrOneJss(i).toFixed(2))
        // newDataVRM.push(this.mzs[i].yrOneJssVrm.toFixed(2))
        newDataVRM.push(this.calcYrOneJssVrm(i).toFixed(2))
      }
      this.chartData = {
        labels: newLabels,
        datasets: [
          {
            label: 'Left Alone',
            backgroundColor: 'hsl(39, 100%, 70%)',
            data: newData
          },
          {
            label: 'With VRM',
            backgroundColor: 'hsl(163, 40%, 70%)',
            data: newDataVRM
          }
        ]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/visualizations/YrOneJssBar.vue